import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';

import { CopySourceAdapter, commonCopySourceAdapts } from './copysource.adapter';
import { CopyActivity } from 'app/model/pipeline/copy.activity';
import { QuickBooksCopySource } from 'app/model/pipeline/copysource/quick-books.copysource';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(QuickBooksCopySource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts,
        query: '*'
    }
})
export class QuickBooksCopySourceAdapter extends CopySourceAdapter<QuickBooksCopySource, Model.QuickBooksSource> {
    protected override async _toResource(copySource: QuickBooksCopySource): Promise<Model.QuickBooksSource> {
        return this._toTabularResource(copySource, Metamodel.modelFor(QuickBooksCopySource).name);
    }

    protected override async _toModel(
        resource: Model.QuickBooksSource,
        copyActivity: CopyActivity
    ): Promise<QuickBooksCopySource> {
        return this._toTabularModel(resource, copyActivity, QuickBooksCopySource.MODEL);
    }
}
